// Presentation-only campaign status labels for hosted microsites.
// Internal enum values (e.g. UNDER_REVIEW) stay untouched for API payloads,
// filtering, permissions, analytics, and persistence — this maps them to
// human-readable display labels at render time only.
const CAMPAIGN_STATUS_LABELS = Object.freeze({
  UNDER_REVIEW: "UNDER REVIEW",
  IN_PROGRESS: "IN PROGRESS",
  READY_FOR_REVIEW: "READY FOR REVIEW",
  NEEDS_REAPPROVAL: "NEEDS REAPPROVAL",
  REPORTING_ONLY: "REPORTING ONLY",
  COMPLETED: "COMPLETED",
  COMPLETE: "COMPLETE",
  DRAFT: "DRAFT",
  PAUSED: "PAUSED",
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  COUNTERSIGNED: "COUNTERSIGNED",
  EXECUTED: "EXECUTED",
  ARCHIVED: "ARCHIVED",
  CANCELED: "CANCELED",
  CANCELLED: "CANCELLED",
});

const formatCampaignStatusLabel = (status) => {
  const text = String(status ?? "").trim();
  if (!text) return "";
  const mapped = CAMPAIGN_STATUS_LABELS[text] || CAMPAIGN_STATUS_LABELS[text.toUpperCase()];
  if (mapped) return mapped;
  return text.replace(/_/g, " ").replace(/\s+/g, " ").trim();
};

export { CAMPAIGN_STATUS_LABELS, formatCampaignStatusLabel };
